import React from 'react';
import { Link } from 'react-router-dom';
import { Checkbox } from '../ui/checkbox';

const QuoteServiceRow = ({ service, selected, tierIndex, onToggle, onTierChange }) => (
  <div
    data-testid={`quote-row-${service.slug}`}
    className={`rounded-xl border p-5 transition-colors ${selected ? 'border-orange-400 bg-orange-50' : 'border-gray-200 bg-white'}`}
  >
    <div className="flex items-start gap-4">
      <Checkbox
        id={`quote-${service.slug}`}
        data-testid={`quote-check-${service.slug}`}
        checked={selected}
        onCheckedChange={onToggle}
        className="mt-1 h-5 w-5 !min-h-0 !min-w-0 data-[state=checked]:bg-[#D97904] data-[state=checked]:border-[#D97904]"
      />
      <div className="flex-1 min-w-0">
        <div className="flex flex-wrap items-baseline justify-between gap-2">
          <label htmlFor={`quote-${service.slug}`} className="font-bold text-gray-900 cursor-pointer">
            {service.title}
          </label>
          <Link to={`/services/${service.slug}`} className="text-xs font-semibold hover:underline !min-h-0 !min-w-0 inline-flex items-center" style={{ color: '#D97904' }}>
            Details
          </Link>
        </div>
        <p className="text-sm text-gray-500">{service.tagline}</p>
        {selected && (
          <div className="mt-4 grid grid-cols-1 xs:grid-cols-3 sm:grid-cols-3 gap-2" data-testid={`quote-tiers-${service.slug}`}>
            {service.tiers.map((t, i) => (
              <button
                key={t.name}
                type="button"
                data-testid={`quote-tier-${service.slug}-${t.name.toLowerCase()}`}
                onClick={() => onTierChange(i)}
                className={`rounded-lg border px-3 py-2 flex sm:block items-center justify-between transition-colors ${
                  i === tierIndex ? 'bg-gray-900 text-white border-gray-900' : 'bg-white text-gray-800 border-gray-200 hover:border-gray-400'
                }`}
              >
                <span className="block text-[10px] uppercase tracking-wide opacity-80">{t.name}</span>
                <span className="block font-bold text-sm sm:text-base">${t.price.toLocaleString()}</span>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  </div>
);

export default QuoteServiceRow;
